import * as React from 'react';
import 'classnames';
import '@grandvisionhq/elements';
import '@grandvisionhq/forms';
import '@grandvisionhq/state';
import '@grandvisionhq/analytics';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import '../../../../../types/product.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import '@swc/helpers';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/common';
import '@grandvisionhq/icons';
import 'use-onclickoutside';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/frk-routing';
import { PrescriptionAvailabilityTagContainer } from '../../../components/PrescriptionAvailabilityTag/PrescriptionAvailabilityTagContainer.js';
import '../../../../../hooks/use-product-view-history.js';
import '@grandvisionhq/inventory';
import { ProductTag } from '../../../components/ProductTag/ProductTag.js';
import '../../../../../slots/context.js';
import 'usehooks-ts';
import '../../../../VTO/context/VtoProvider.js';
import '@grandvisionhq/content';

const SunglassesTags = ()=>/*#__PURE__*/ React.createElement("div", {
        className: "sunglasses-tags"
    }, /*#__PURE__*/ React.createElement(ProductTag, null), /*#__PURE__*/ React.createElement(PrescriptionAvailabilityTagContainer, null))
;

export { SunglassesTags };
//# sourceMappingURL=SunglassesTags.js.map
